import React, { useState, useEffect } from "react";
import openSocket from "../../services/socket-io.js";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

import { toast } from "react-toastify";

import Tooltip from "@material-ui/core/Tooltip";

import api from "../../services/api.js";
import { i18n } from "../../translate/i18n.js";
import toastError from "../../errors/toastError.js";
import { CircularProgress, Grid } from "@material-ui/core";
import MainContainer from "../../components/MainContainer/index.js";
import MainHeader from "../../components/MainHeader/index.js";
import Title from "../../components/Title/index.js";
import useWhatsApps from "../../hooks/useWhatsApps";


const useStyles = makeStyles(theme => ({
	root: {
		display: "flex",
		alignItems: "center",
		padding: theme.spacing(8, 8, 3),
	},

	paper: {
		padding: theme.spacing(2),
		display: "flex",
		alignItems: "center",
		marginBottom: 12,

	},

	settingOption: {
		marginLeft: "auto",
	},
	margin: {
		margin: theme.spacing(1),
	},
	mainPaper: {
		flex: 1,
		padding: theme.spacing(1),
		overflowY: "scroll",
		...theme.scrollbarStyles,
	},
	maxWidth: {
		width: "100%",
	},

}));

const ControlPanel = () => {
	const classes = useStyles();

	const [settings, setSettings] = useState([]);
	const [selectedWhatsapp, setSelectedWhatsapp] = useState();
	const { logImport, setLogImport } = useState([]);
	const [ openLog, setOpenLog ] = useState(false);
	const [loadingImport, setLoadingImport] = useState(false);

	const { loadingWhatsapps, whatsApps } = useWhatsApps();


	useEffect(() => {
		const fetchSession = async () => {
			try {
				const { data } = await api.get("/settings");
				
				// Lista de configurações obrigatórias com valores padrão
				const requiredSettings = [
					{ key: "userCreation", value: "enabled" },
					{ key: "chatBotType", value: "text" },
					{ key: "userQuantity", value: "0" },
					{ key: "conectionQuantity", value: "0" },
					{ key: "moduleCalendar", value: "enabled" },
					{ key: "moduleInternalChat", value: "enabled" },
					{ key: "moduleSms", value: "enabled" },
					{ key: "moduleApi", value: "enabled" },
					{ key: "moduleAutoSchedule", value: "enabled" }
				];

				// Verificar e criar configurações faltantes
				const createdSettings = [];
				for (const requiredSetting of requiredSettings) {
					const exists = data.find(s => s.key === requiredSetting.key);
					if (!exists) {
						try {
							const response = await api.post("/settings", {
								key: requiredSetting.key,
								value: requiredSetting.value
							});
							createdSettings.push(response.data);
						} catch (createErr) {
							console.error(`Erro ao criar setting ${requiredSetting.key}:`, createErr);
						}
					}
				}

				// Combinar settings existentes com as criadas
				const allSettings = createdSettings.length > 0 
					? [...data, ...createdSettings] 
					: data;
				
				setSettings(allSettings);
			} catch (err) {
				console.error("💥 Erro ao carregar settings:", err);
				toastError(err);
			}
		};
		fetchSession();
	}, []);

	useEffect(() => {
		const socket = openSocket();

		socket.on("settings", data => {
			if (data.action === "update") {
				setSettings(prevState => {
					const aux = [...prevState];
					const settingIndex = aux.findIndex(s => s.key === data.setting.key);
					if (settingIndex !== -1) {
						aux[settingIndex].value = data.setting.value;
					}
					return aux;
				});
			}
			
			if (data.action === "create") {
				setSettings(prevState => {
					const aux = [...prevState];
					const settingIndex = aux.findIndex(s => s.key === data.setting.key);
					if (settingIndex !== -1) {
						aux[settingIndex].value = data.setting.value;
					} else {
						aux.push(data.setting);
					}
					return aux;
				});
			}
		});

		return () => {
			socket.disconnect();
		};
	}, []);

	const handleChangeSetting = async e => {
		const selectedValue = e.target.value;
		const settingKey = e.target.name;

		try {
			await api.put(`/settings/${settingKey}`, {
				value: selectedValue,
			});
			toast.success(i18n.t("settings.success"));
		} catch (err) {
			toastError(err);
		}
	};

	const getSettingValue = key => {
		const setting = settings.find(s => s.key === key);
		return setting ? setting.value : "";
	};

	const importChatsAndMessages = async (whatsappId) => {
		setLoadingImport(true);
		try {

			if (!whatsappId) {
				toast.error("Selecione uma conexão");
				return;
			} else {
				const imports = await api.post("/import/chats", { whatsappId });
				toast.success(i18n.t("settings.success"));

				setLogImport(imports.data);
				setOpenLog(true);
			}
		} catch (err) {
			toastError(err);
		} finally {
			setLoadingImport(false);
		}
	};	
	
	return (

		<MainContainer className={classes.container} >
			<MainHeader>
				<Title>Painel de Controle</Title>
			</MainHeader>
			<Paper className={classes.mainPaper} variant="outlined">
			{/* OCULTO: Criação de Usuário (padrão: disabled) */}
			{/* <Paper className={classes.paper}>
				<Typography variant="body1">
					{i18n.t("settings.settings.userCreation.name")}
				</Typography>
				<Select
					margin="dense"
					variant="outlined"
					native
					id="userCreation-setting"
					name="userCreation"
					value={
						settings && settings.length > 0 && getSettingValue("userCreation")
					}
					className={classes.settingOption}
					onChange={handleChangeSetting}
				>
					<option value="enabled">
						{i18n.t("settings.settings.userCreation.options.enabled")}
					</option>
					<option value="disabled">
						{i18n.t("settings.settings.userCreation.options.disabled")}
					</option>
				</Select>
			</Paper> */}
			{/*	<Paper className={classes.paper}>
					<Typography variant="body1">
						Tipo do Chatbot
					</Typography>
					<Select
						margin="dense"
						variant="outlined"
						native
						id="chatBotType-setting"
						name="chatBotType"
						value={settings && settings.length > 0 && getSettingValue("chatBotType")}
						className={classes.settingOption}
						onChange={handleChangeSetting}
					>
						<option value="text">
							Texto
						</option>

						<option value="button">
							Botão
						</option>

						<option value="list">
							Lista
						</option>

					</Select>
				</Paper> */}

				{/* Configurações de Quantidade de Usuários e Conexões */}

				<Paper className={classes.paper}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={6}>
							<TextField
								id="user-quantity-setting"
								readonly
								label="Quantidade de usuários"
								name="userQuantity"
								margin="dense"
								variant="outlined"
								fullWidth
								value={settings && settings.length > 0 && getSettingValue("userQuantity")}
								onChange={handleChangeSetting}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<TextField
								id="conection-quantity-setting"
								readonly
								label="Quantidade de conexões"
								name="conectionQuantity"
								margin="dense"
								variant="outlined"
								fullWidth
								value={settings && settings.length > 0 && getSettingValue("conectionQuantity")}
								onChange={handleChangeSetting}
							/>

						</Grid>

					</Grid>

				</Paper>

				{/* Controle de Módulos do Sistema */}
				<Paper className={classes.paper}>
					<Typography variant="h6" style={{ marginBottom: 16, fontWeight: 600 }}>
						Módulos do Sistema
					</Typography>
					
					<Grid container spacing={2}>
						{/* Módulo Calendário */}
						<Grid item xs={12} sm={6}>
							<Paper className={classes.paper} style={{ backgroundColor: '#f5f5f5' }}>
								<Typography variant="body1">
									📅 Calendário
								</Typography>
								<Select
									margin="dense"
									variant="outlined"
									native
									name="moduleCalendar"
									value={settings && settings.length > 0 && getSettingValue("moduleCalendar")}
									className={classes.settingOption}
									onChange={handleChangeSetting}
								>
									<option value="enabled">Ativado</option>
									<option value="disabled">Desativado</option>
								</Select>
							</Paper>
						</Grid>

						{/* Módulo Chat Interno */}
						<Grid item xs={12} sm={6}>
							<Paper className={classes.paper} style={{ backgroundColor: '#f5f5f5' }}>
								<Typography variant="body1">
									💬 Chat Interno
								</Typography>
								<Select
									margin="dense"
									variant="outlined"
									native
									name="moduleInternalChat"
									value={settings && settings.length > 0 && getSettingValue("moduleInternalChat")}
									className={classes.settingOption}
									onChange={handleChangeSetting}
								>
									<option value="enabled">Ativado</option>
									<option value="disabled">Desativado</option>
								</Select>
							</Paper>
						</Grid>

						{/* Módulo SMS */}
						<Grid item xs={12} sm={6}>
							<Paper className={classes.paper} style={{ backgroundColor: '#f5f5f5' }}>
								<Typography variant="body1">
									📱 SMS
								</Typography>
								<Select
									margin="dense"
									variant="outlined"
									native
									name="moduleSms"
									value={settings && settings.length > 0 && getSettingValue("moduleSms")}
									className={classes.settingOption}
									onChange={handleChangeSetting}
								>
									<option value="enabled">Ativado</option>
									<option value="disabled">Desativado</option>
								</Select>
							</Paper>
						</Grid>

						{/* Módulo API */}
						<Grid item xs={12} sm={6}>
							<Paper className={classes.paper} style={{ backgroundColor: '#f5f5f5' }}>
								<Typography variant="body1">
									🔌 API Externa
								</Typography>
								<Select
									margin="dense"
									variant="outlined"
									native
									name="moduleApi"
									value={settings && settings.length > 0 && getSettingValue("moduleApi")}
									className={classes.settingOption}
									onChange={handleChangeSetting}
								>
									<option value="enabled">Ativado</option>
									<option value="disabled">Desativado</option>
								</Select>
							</Paper>
						</Grid>

						{/* Módulo Auto Agendamento */}
						<Grid item xs={12} sm={6}>
							<Paper className={classes.paper} style={{ backgroundColor: '#f5f5f5' }}>
								<Typography variant="body1">
									🤖 Auto Agendamento
								</Typography>
								<Select
									margin="dense"
									variant="outlined"
									native
									name="moduleAutoSchedule"
									value={settings && settings.length > 0 && getSettingValue("moduleAutoSchedule")}
									className={classes.settingOption}
									onChange={handleChangeSetting}
								>
									<option value="enabled">Ativado</option>
									<option value="disabled">Desativado</option>
								</Select>
							</Paper>
						</Grid>
					</Grid>
				</Paper>
			</Paper>
		</MainContainer>
	);
};

export default ControlPanel;